import React, { useState, useEffect, useCallback } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faPlus, faXmark, faCheck } from '@fortawesome/free-solid-svg-icons';
import apiClient from "../../axios";
import LoginNotification from "../Notifications/LoginNotification";
import './AddWhatsAppTemplatePermissions.css';
import Loader from "../Loader";
import SuccessProcess from '../Notifications/SuccessProcess';

const AddWhatsAppTemplatePermissions = ({ isVisible, onClose, id, makiId }) => {
    const [templates, setTemplates] = useState([]);
    const [permissions, setPermissions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isLoginVisible, setIsLoginVisible] = useState(false);
    const [successVisible, setSuccessVisible] = useState(false);


    const fetchUserPermissions = useCallback(async () => {
        try {

            const response = await apiClient.get(`/whatsappDetails/permissions/user/${makiId}`);

            if (response.data?.data?.length > 0) {
                const mapped = response.data.data.map(item => ({
                    sendType: item.sendKind,
                    templateId: item.templateId,
                    priority: item.priority,
                    active: item.flagActive === 1
                }));

                setPermissions(mapped);

            } else {
                setPermissions([]); // sin datos
            }

        } catch (error) {
            if (error.response && error.response.status === 401) {
                setIsLoginVisible(true);
            }
        }
    }, [makiId]);
    // Obtener templates
    const fetchTemplates = useCallback(async () => {
        try {

            setLoading(true);

            const response = await apiClient.get(`/whatsappDetails/permissions?page=1`);

            if (response.data.results) {
                setTemplates(response.data.results);
            }

        } catch (error) {

            if (error.response && error.response.status === 401) {
                setIsLoginVisible(true);
            }

        } finally {
            setLoading(false);
        }

    }, []);

    useEffect(() => {
        fetchTemplates();
        fetchUserPermissions();
    }, [fetchTemplates,fetchUserPermissions]);



    const handleAddPermission = () => {

        setPermissions([
            ...permissions,
            {
                sendType: "text",
                templateId: "",
                priority: 100,
                active: true
            }
        ]);

    };



    const handleRemove = (index) => {

        const newPermissions = [...permissions];
        newPermissions.splice(index, 1);
        setPermissions(newPermissions);

    };



    const handleChange = (index, field, value) => {

        const newPermissions = [...permissions];
        if (field === "sendType") {
            newPermissions[index].templateId = "";
        }
        newPermissions[index][field] = value;
        setPermissions(newPermissions);

    };

    const buildPayload = () => {
        return permissions.map(row => ({
            sendKind: row.sendType,
            templateId: Number(row.templateId),
            priority: Number(row.priority),
            flagActive: row.active
        }));
    };

    const handleCloseSuccess = () => {
        setSuccessVisible(false);
        onClose();
    };

    const handleSave = async () => {

        try {

            setLoading(true);
            const permissions = buildPayload();
            const payload = {
                makiId,
                permissions
            };
            console.log(payload);
            const result = await apiClient.post(`/whatsappDetails/permissions/${id}`, payload);
            if (result.status === 201) {
                setSuccessVisible(true);
            }
        } catch (error) {
            if (error.response && error.response.status === 401) {
                setIsLoginVisible(true);
            }

        } finally {
            setLoading(false);
        }

    };


    return (
        isVisible && (
            <div className="modal-overlay">
                <div className="modal-content-module">
                    <div className="permission-container">
                        <h3 className="modal-title ">Permisos templates cloud</h3>

                        <button
                            className="new-permission-btn"
                            onClick={handleAddPermission}
                        >
                            <FontAwesomeIcon icon={faPlus} /> Nuevo permiso
                        </button>
                        <div className="permission-header">
                            <span>TIPO ENVÍO</span>
                            <span>TEMPLATE</span>
                            <span>PRIORIDAD</span>
                            <span>ESTADO</span>
                            <span></span> {/* para el icono eliminar */}
                        </div>
                        {permissions.map((item, index) => (

                            <div className="permission-row" key={index}>

                                {/* Tipo envío */}
                                <select
                                    value={item.sendType}
                                    onChange={(e) =>
                                        handleChange(index, "sendType", e.target.value)
                                    }
                                >
                                    <option value="text">Texto</option>
                                    <option value="document">Documento</option>
                                    <option value="image">Imagen</option>
                                </select>


                                {/* Template */}
                                <select
                                    value={item.templateId}
                                    onChange={(e) =>
                                        handleChange(index, "templateId", e.target.value)
                                    }
                                >

                                    <option value="">Seleccione</option>

                                    {templates.map((template) => (

                                        <option key={template.id} value={template.id}>
                                            {template.templateName} ({template.templateLanguage})
                                        </option>

                                    ))}

                                </select>


                                {/* Prioridad */}
                                <input
                                    type="number"
                                    value={item.priority}
                                    onChange={(e) =>
                                        handleChange(index, "priority", e.target.value)
                                    }
                                />


                                {/* Activo */}
                                <input
                                    type="checkbox"
                                    checked={item.active}
                                    onChange={(e) =>
                                        handleChange(index, "active", e.target.checked)
                                    }
                                />


                                <button onClick={() => handleRemove(index)}>
                                    <FontAwesomeIcon icon={faTrash} />
                                </button>

                            </div>

                        ))}




                    </div>



                    <div className="modulesmodal-basic-form-footer">

                        <button
                            className="basic-custom-button"
                            onClick={onClose}
                        >
                            <FontAwesomeIcon icon={faXmark} className="basic-shortcut-icon" />
                            Cancelar
                        </button>

                        <button
                            className="basic-custom-button"
                            onClick={handleSave}
                        >
                            <FontAwesomeIcon icon={faCheck} className="basic-shortcut-icon" />
                            Guardar
                        </button>

                    </div>


                </div>
                {loading && <Loader />}
                <LoginNotification
                    message="Vuelva a iniciar sesión"
                    isVisible={isLoginVisible}
                    onClose={() => setIsLoginVisible(false)}
                />
                <SuccessProcess
                    message={"Se asignado los Permisos correctamente."}
                    isVisible={successVisible}
                    onClose={handleCloseSuccess}
                    redirectOnOk={false}
                    whatsApp={false}
                />

            </div>
        )
    );
};
export default AddWhatsAppTemplatePermissions;
